import React, {useCallback, useState} from "react";
import {ConfigProvider} from "antd";
import {FormModal} from "../../../../components/index.jsx";
import {isEmpty, set} from "lodash";
import common from "@well-b/well-b-shared";
import {PHONE_NUMBER_ERROR_VALIDATION} from "../../../../marketplace/consts.jsx";
import {isValidEmailRegex} from "../../../../components/form/validators.jsx";

export const UploadDeliveryProviderDriverModal = ({visible, onClose, onSave, deliveryProviderDriver}) => {
    const [formValuesChanges, setFormChangesValues] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const onUpdate = useCallback((_, changedField) => {
        const [key, value] = Object.entries(changedField)[0];
        setFormChangesValues(currentFormValues => set({...currentFormValues}, key, value));
    }, []);

    const innerClose = useCallback(() => {
        setFormChangesValues({});
        onClose();
    }, [onClose]);

    const onFinish = useCallback(async () => {
        if (isEmpty(formValuesChanges)) {
            return false;
        }
        setIsLoading(true);
        const isSuccess = await onSave(formValuesChanges);
        if (isSuccess) {
            innerClose();
        }
        setIsLoading(false);
        return isSuccess;
    }, [formValuesChanges, onSave, innerClose]);

    return (
        <ConfigProvider direction="rtl">
            <FormModal
                content={deliveryProviderDriver ?? {}}
                header={isEmpty(deliveryProviderDriver) ? "הוספת נהג" : "עדכון נהג"}
                subTitle="אנא מלאו את הפרטים הבאים"
                visible={visible}
                onClose={innerClose}
                onSave={innerClose}
                onUpdate={onUpdate}
                validationFunction={onFinish}
                isConfirmButtonLoading={isLoading}
                fields={[
                    {
                        name: "name",
                        label: "שם נהג"
                    },
                    {
                        name: "phone",
                        label: "טלפון",
                        rules: [
                            {
                                validator: (_, value) => {
                                    return common.isValidPhoneMobileNumber(value)
                                        ? Promise.resolve()
                                        : Promise.reject(PHONE_NUMBER_ERROR_VALIDATION);
                                }
                            }
                        ]
                    },
                    {
                        name: "email",
                        label: "מייל התחברות",
                        rules: [
                            {
                                validator: async (_, email) => {
                                    if (email?.length && !isValidEmailRegex(email)) {
                                        throw new Error("פרטי המייל אינם תקינים");
                                    }
                                }
                            }
                        ]
                    },
                    {
                        name: "idNumber",
                        label: "מספר תעודת זהות"
                    },
                    {
                        name: "licenseNumber",
                        label: "מספר רכב"
                    }
                ]}
            />
        </ConfigProvider>
    );
};
